export default "__VITE_ASSET__D8SV8GXI__"